import { render } from "./sliderImage.vue?vue&type=template&id=20255d1e"
import script from "./sliderImage.vue?vue&type=script&lang=js"
export * from "./sliderImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__